import { render, staticRenderFns } from "./RegulationCard.vue?vue&type=template&id=7c4c440a&scoped=true&"
import script from "./RegulationCard.vue?vue&type=script&lang=ts&"
export * from "./RegulationCard.vue?vue&type=script&lang=ts&"
import style0 from "./RegulationCard.vue?vue&type=style&index=0&id=7c4c440a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c440a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VIcon,VSkeletonLoader,VTooltip})
